import { handleAction, handleActions } from "redux-actions";
import { createCrudReducers } from "../../utils/crudGenerator";
import {
  ADD_NEW_ALERT,
  ALERT_FORM_TOOGLE_LOADING,
  AUTH,
  CLOSE_ALERT_FORM,
  CLOSE_NOTIFICATION,
  DELETE_ALERT,
  EDIT_SELECTED_ALERT,
  LOGOUT,
  OPEN_ALERT_FORM,
  SET_ALERT_LIST,
  SET_BC_USERS_LIST,
  SET_CURRENT_ROUTE,
  SET_PROFILE,
  SET_PROJECTSNAV_LIST,
  SET_SIDE_MENU_STATE,
  SHOW_NOTIFICATION,
  THEME,
  UPDATE_ALERT
} from "./../../constants";

/* BASIC */
export const authorization = handleActions(
  {
    [AUTH]: (state, action) => action.payload,
    [LOGOUT]: () => ({ auth: false }),
  },
  null
);

/* PROFILE */
export const profile = handleActions(
  {
    [SET_PROFILE]: (state, action) => action.payload,
  },
  null
);

/* APP */
export const currentRoute = handleAction(
  SET_CURRENT_ROUTE,
  (state, action) => action.payload,
  {}
);

export const notifications = handleActions(
  {
    [SHOW_NOTIFICATION]: (state, action) => action.payload,
    [CLOSE_NOTIFICATION]: (state, action) => ({
      show: false,
      status: null,
      message: null,
    }),
  },
  { show: false, status: null, message: null }
);

/* APP */
export const app = handleActions(
  {
    [SET_SIDE_MENU_STATE]: (state, action) => {
      return { ...state, isCollapsedSideMenu: action.payload };
    },
  },
  { isCollapsedSideMenu: true }
);

export const currentTheme = handleAction(
  THEME,
  (state, action) => action.payload,
  false
);

export const alerts = handleActions(
  {
    [SET_ALERT_LIST]: (state, action) => action.payload,
    [ADD_NEW_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [UPDATE_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [DELETE_ALERT]: (state, action) => {
      action.payload.forEach((number) => {
        delete state[number];
      });
      return { ...state };
    },
  },
  null
);

export const alertsForm = handleActions(
  {
    [OPEN_ALERT_FORM]: (state) => ({
      show: !state.show,
      data: null,
      loading: false,
    }),
    [CLOSE_ALERT_FORM]: () => ({ show: false, data: null, loading: false }),
    [EDIT_SELECTED_ALERT]: (s, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [ALERT_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

const userReducers = createCrudReducers('USER');

export const users = userReducers.list;
export const usersForm = userReducers.form;

const budgetReducers = createCrudReducers('BUDGET');

export const budgets = budgetReducers.list;
export const budgetsForm = budgetReducers.form;

export const bcUsers = handleActions(
  {
    [SET_BC_USERS_LIST]: (state, action) => action.payload,
  },
  null
);

export const products = (state = null, action) => {
    switch (action.type) {
        case 'SET_PRODUCTS_LIST':
            return action.payload;
        case 'SET_PRODUCTS_ERROR':
            return { error: action.payload };
        case 'ADD_NEW_PRODUCTS':
        case 'UPDATE_PRODUCTS':
            return { ...state, [action.payload._id]: action.payload };
        case 'DELETE_PRODUCTS':
            return Object.keys(state)
                .filter(key => !action.payload.includes(key))
                .reduce((obj, key) => {
                    obj[key] = state[key];
                    return obj;
                }, {});
        default:
            return state;
    }
};


export const projectsnav = handleActions(
  {
    [SET_PROJECTSNAV_LIST]: (state, action) => action.payload,
  },
  null
);